module.exports = __webpack_public_path__ + "img/demo.3124f831.png";